import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HTTP_OPTIONS, URL_SERVICIOS } from '../shared/config/config';
import { Template } from '../interfaces/template';
import { DatatableRootObject } from '../interfaces/datatable-root-object';
import { DataTablesResponse } from '../interfaces/datatables-response';
const URL = `${URL_SERVICIOS}template`;

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  constructor(private http: HttpClient) { }

  getTemplates = (tableObj: DatatableRootObject) => this.http.post<DataTablesResponse<Template>>(`${URL}/datatable`, tableObj, HTTP_OPTIONS);

  getAllTemplates = () => this.http.get<Template[]>(URL);

  getTemplate = (id: number) => this.http.get<Template>(`${URL}/${id}`);

  addTemplate = (data: Template) => this.http.post<number>(URL, JSON.stringify(data), HTTP_OPTIONS);

  updateTemplate = (id: number, data: Template) => this.http.put(`${URL}/${id}`, JSON.stringify(data), HTTP_OPTIONS);
  
  changeTemplate = (id: number, data: any) => this.http.patch(`${URL}/${id}`, JSON.stringify(data), HTTP_OPTIONS);
  
  deleteTemplate = (id: number) => this.http.delete(`${URL}/${id}`);
}
